export const hotSearchLiveData = [
    {
        "id": 1,
        "image": require("../images/hotsearchLive/live_01.webp"),
        "imageSmall": require("../images/hotsearchLive/live_01_330w.webp"),
        "name": "趣淘漫旅",
        "link": "https://www.pixnet.net/ppage/趣淘漫旅"
    },
    {
        "id": 2,
        "image": require("../images/hotsearchLive/live_02.webp"),
        "imageSmall": require("../images/hotsearchLive/live_02_330w.webp"),
        "name": "台南香格里拉",
        "link": "https://www.pixnet.net/ppage/台南香格里拉"
    },
    {
        "id": 3,
        "image": require("../images/hotsearchLive/live_03.webp"),
        "imageSmall": require("../images/hotsearchLive/live_03_330w.webp"),
        "name": "台南晶英酒店",
        "link": "https://www.pixnet.net/ppage/台南晶英酒店"
    },
    {
        "id": 4,
        "image": require("../images/hotsearchLive/live_04.webp"),
        "imageSmall": require("../images/hotsearchLive/live_04_330w.webp"),
        "name": "福爾摩沙遊艇酒店",
        "link": "https://beeandpanda.pixnet.net/blog/post/73920253"
    },
    {
        "id": 5,
        "image": require("../images/hotsearchLive/live_05.webp"),
        "imageSmall": require("../images/hotsearchLive/live_05_330w.webp"),
        "name": "南科贊美酒店",
        "link": "https://www.pixnet.net/ppage/南科贊美酒店"
    },
    {
        "id": 6,
        "image": require("../images/hotsearchLive/live_06.webp"),
        "imageSmall": require("../images/hotsearchLive/live_06_330w.webp"),
        "name": "夏都城旅安平館",
        "link": "https://yoyoman822.pixnet.net/blog/post/68775929?utm_source=PIXNET&utm_medium=ppage"
    },
    {
        "id": 7,
        "image": require("../images/hotsearchLive/live_07.webp"),
        "imageSmall": require("../images/hotsearchLive/live_07_330w.webp"),
        "name": "景大渡假莊園",
        "link": "https://saliha.pixnet.net/blog/post/561338258"
    },
    {
        "id": 8,
        "image": require("../images/hotsearchLive/live_08.webp"),
        "imageSmall": require("../images/hotsearchLive/live_08_330w.webp"),
        "name": "南人旅人",
        "link": "https://www.pixnet.net/ppage/南人旅人"
    },
    {
        "id": 9,
        "image": require("../images/hotsearchLive/live_09.webp"),
        "imageSmall": require("../images/hotsearchLive/live_09_330w.webp"),
        "name": "禧榕軒大飯店",
        "link": "https://www.pixnet.net/ppage/禧榕軒大飯店"
    },
    {
        "id": 10,
        "image": require("../images/hotsearchLive/live_10.webp"),
        "imageSmall": require("../images/hotsearchLive/live_10_330w.webp"),
        "name": "康橋慢旅",
        "link": "https://god963963.pixnet.net/blog/post/121605191"
    },
    {
        "id": 11,
        "image": require("../images/hotsearchLive/live_11.webp"),
        "imageSmall": require("../images/hotsearchLive/live_11_330w.webp"),
        "name": "山籟渡假會館",
        "link": "https://www.pixnet.net/ppage/山籟渡假會館"
    },
    {
        "id": 12,
        "image": require("../images/hotsearchLive/live_12.webp"),
        "imageSmall": require("../images/hotsearchLive/live_12_330w.webp"),
        "name": "台南和逸飯店",
        "link": "https://disni.pixnet.net/blog/post/45206118"
    },
    {
        "id": 13,
        "image": require("../images/hotsearchLive/live_13.webp"),
        "imageSmall": require("../images/hotsearchLive/live_13_330w.webp"),
        "name": "衡定理台南安平民宿",
        "link": "https://www.pixnet.net/ppage/衡定理台南安平民宿"
    },
    {
        "id": 14,
        "image": require("../images/hotsearchLive/live_14.webp"),
        "imageSmall": require("../images/hotsearchLive/live_14_330w.webp"),
        "name": "台南老爺行旅",
        "link": "https://www.pixnet.net/ppage/台南老爺行旅"
    },
    {
        "id": 15,
        "image": require("../images/hotsearchLive/live_15.webp"),
        "imageSmall": require("../images/hotsearchLive/live_15_330w.webp"),
        "name": "溜小孩親子民宿",
        "link": "https://www.pixnet.net/ppage/溜小孩親子民宿"
    },
    {
        "id": 16,
        "image": require("../images/hotsearchLive/live_16.webp"),
        "imageSmall": require("../images/hotsearchLive/live_16_330w.webp"),
        "name": "澄居行旅",
        "link": "https://www.pixnet.net/ppage/澄居行旅"
    },
    {
        "id": 17,
        "image": require("../images/hotsearchLive/live_17.webp"),
        "imageSmall": require("../images/hotsearchLive/live_17_330w.webp"),
        "name": "台南煙波大飯店",
        "link": "https://enlifesun.com/blog/post/121391504"
    },
    {
        "id": 18,
        "image": require("../images/hotsearchLive/live_18.webp"),
        "imageSmall": require("../images/hotsearchLive/live_18_330w.webp"),
        "name": "致穩人文商旅",
        "link": "https://cindy998.pixnet.net/blog/post/335836349"
    },
    {
        "id": 19,
        "image": require("../images/hotsearchLive/live_19.webp"),
        "imageSmall": require("../images/hotsearchLive/live_19_330w.webp"),
        "name": "友愛街旅館",
        "link": "https://reinmiso.pixnet.net/blog/post/563338666"
    },
    {
        "id": 20,
        "image": require("../images/hotsearchLive/live_20.webp"),
        "imageSmall": require("../images/hotsearchLive/live_20_330w.webp"),
        "name": "仙湖休閒農場",
        "link": "https://pk55168.pixnet.net/blog/post/64758193"
    },
    {
        "id": 21,
        "image": require("../images/hotsearchLive/live_21.webp"),
        "imageSmall": require("../images/hotsearchLive/live_21_330w.webp"),
        "name": "台南安平雅樂軒酒店",
        "link": "https://www.pixnet.net/ppage/台南安平雅樂軒酒店"
    },
    {
        "id": 22,
        "image": require("../images/hotsearchLive/live_22.webp"),
        "imageSmall": require("../images/hotsearchLive/live_22_330w.webp"),
        "name": "月亮慢慢走",
        "link": "https://www.pixnet.net/ppage/月亮慢慢走"
    },
    {
        "id": 23,
        "image": require("../images/hotsearchLive/live_23.webp"),
        "imageSmall": require("../images/hotsearchLive/live_23_330w.webp"),
        "name": "月見溪行館",
        "link": "https://ta40219.pixnet.net/blog/post/50113060"
    },
    {
        "id": 24,
        "image": require("../images/hotsearchLive/live_24.webp"),
        "imageSmall": require("../images/hotsearchLive/live_24_330w.webp"),
        "name": "家新大飯店",
        "link": "https://chenuc999.pixnet.net/blog/post/69190448"
    },
    {
        "id": 25,
        "image": require("../images/hotsearchLive/live_25.webp"),
        "imageSmall": require("../images/hotsearchLive/live_25_330w.webp"),
        "name": "fun假旅店",
        "link": "https://www.pixnet.net/ppage/fun假旅店"
    }
];
